// import AnimateHarmony from '../assets/img/Projects/AnimteHarmony.png';
import LogoAnimation from '../assets/img/Projects/LogoAnimation.png';
import korean from '../assets/img/Projects/korean.png';
import masari from '../assets/img/Projects/masari.jpg';
import seedAndSteam from '../assets/img/Projects/seedAndSteam.png';
import tagPluse from '../assets/img/Projects/tagPlus.gif';
import intro_saudi_film from '../assets/img/Projects/intro_saudi-film.png';


import HealthMajors_gif from '../assets/img/Projects/HealthMajors.gif';
import HealthMajors_jpg from '../assets/img/Projects/HealthMajors.jpg';

import Mzg from '../assets/img/Projects/Mzg.jpg';
import Qiddam from '../assets/img/Projects/Qiddam.jpg';

import nizamAmervid from '../assets/video/nizamAmer.mp4';
import nizamAmergif from '../assets/video/nizamAmer.gif';
import Ideation from '../assets/video/IDEATION.mp4';
import Ideation_gif from '../assets/video/IDEATION.gif';

import nec_1 from '../assets/video/nec_1.gif';
import nec_2 from '../assets/video/nec_2.gif';
import nec_3 from '../assets/video/nec_3.gif';

import bites from '../assets/img/Projects/bites_full_v1_1.gif';
import ACWA from '../assets/img/Projects/ACWA.png';

export const myProjects = [
	{
		name: 'Saudi Film Festival 2024',
		img: intro_saudi_film,
		id: 1,
		boolean: false,
		description: '',
		link: 'https://www.instagram.com/reel/C6zIB42oLZA/?igsh=MTUwcnVucXhlcHh4cQ==',
	},
	{
		name: 'masari',
		img: masari,
		id: 3,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/145477191/Motion-Explainer-Video-Masari-',
	},
	{
		name: 'Giddam',
		img: Qiddam,
		id: 8,
		boolean: false,
		description: '',
		link: 'https://instagram.com/p/Cll9Zalt1lG/',
	},
	{
		name: 'KSAU-HS',
		img: HealthMajors_gif ? HealthMajors_gif : HealthMajors_jpg,
		id: 6,
		boolean: false,
		description: '',
		link: 'https://www.instagram.com/p/CewUEFEDxCn/?igshid=MzRlODBiNWFlZA==',
	},
	{
		name: 'Mazj',
		img: Mzg,
		id: 7,
		boolean: false,
		description: '',
		link: 'https://www.instagram.com/reel/ClQZSVTDudW/?igshid=MzRlODBiNWFlZA==',
	},

	{
		name: 'korean',
		img: korean,
		id: 2,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/145216681/Korean-shed-Motion-Design',
	},
	{
		name: 'LogoAnimation',
		img: LogoAnimation,
		id: 4,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/146381363/Logo-Animation-V1',
	},

	{
		name: 'seedAndSteam',
		img: seedAndSteam,
		id: 5,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/121650789/Seed-and-Stem',
	},
	// {
	// 	name: 'AnimateHarmony',
	// 	img: AnimateHarmony,
	// 	id: 8,
	// 	boolean: false,
	// 	description: '',
	// 	link: 'https://www.behance.net/gallery/111114531/Animate-an-artwork-named-Harmony',
	// },
];

export const myProjects2 = [
	{
		name: 'bites',
		img: bites,
		id: 14,
		boolean: false,
		description: '',
		link: 'https://streamable.com/e/h3y8b0',
	},
	{
		name: 'ACWA',
		img: ACWA,
		id: 13,
		boolean: false,
		description: '',
		link: 'https://streamable.com/e/9trv0q',
	},
	{
		name: 'Saudi Film Festival 2024',
		img: intro_saudi_film,
		id: 1,
		boolean: false,
		description: '',
		link: 'https://www.instagram.com/reel/C6zIB42oLZA/?igsh=MTUwcnVucXhlcHh4cQ==',
	},
	{
		name: 'SBA | Employees System explainer',
		img: nizamAmergif,
		id: 2,
		boolean: false,
		description: '',
		link: '',
		video: nizamAmervid,
	},
	{
		name: 'National Event Centre Achievement',
		img: [nec_1, nec_2, nec_3],
		id: 3,
		boolean: false,
		description: '',
		link: 'https://streamable.com/e/fc1ds6',
	},	
	{
		name: 'Ideation | Prodaction intro',
		img: Ideation_gif,
		id: 4,
		boolean: false,
		description: '',
		link: '',
		video: Ideation,
	},
	{
		name: 'TagPlus',
		img: tagPluse,
		id: 5,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/146353781/TagPlus-Motion-Graphic',
	},
	{
		name: 'masari',
		img: masari,
		id: 6,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/145477191/Motion-Explainer-Video-Masari-',
	},
	{
		name: 'Giddam',
		img: Qiddam,
		id: 7,
		boolean: false,
		description: '',
		link: 'https://instagram.com/p/Cll9Zalt1lG/',
	},
	{
		name: 'KSAU-HS',
		img: HealthMajors_gif ? HealthMajors_gif : HealthMajors_jpg,
		id: 8,
		boolean: false,
		description: '',
		link: 'https://www.instagram.com/p/CewUEFEDxCn/?igshid=MzRlODBiNWFlZA==',
	},
	{
		name: 'Mazj',
		img: Mzg,
		id: 9,
		boolean: false,
		description: '',
		link: 'https://www.instagram.com/reel/ClQZSVTDudW/?igshid=MzRlODBiNWFlZA==',
	},

	{
		name: 'korean',
		img: korean,
		id: 10,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/145216681/Korean-shed-Motion-Design',
	},
	{
		name: 'LogoAnimation',
		img: LogoAnimation,
		id: 11,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/146381363/Logo-Animation-V1',
	},

	{
		name: 'seedAndSteam',
		img: seedAndSteam,
		id: 12,
		boolean: false,
		description: '',
		link: 'https://www.behance.net/gallery/121650789/Seed-and-Stem',
	},
	// {
	// 	name: 'AnimateHarmony',
	// 	img: AnimateHarmony,
	// 	id: 8,
	// 	boolean: false,
	// 	description: '',
	// 	link: 'https://www.behance.net/gallery/111114531/Animate-an-artwork-named-Harmony',
	// },
];
